<template>
    <div class="components-container">
        <el-row>
            <el-col :span="8">
                <el-row>
                    <div class="titles">
                        <span class="fonts">职业领域</span>
                        <el-button @click="addElement('domain')" type="success" size="mini" style="margin-left:15px;" :disabled="editDisableState">
                            <i class="el-icon-plus"></i>
                        </el-button>
                        <el-button @click="popGrid('domain')" type="danger" size="mini" :disabled="editDisableState">
                            <i class="el-icon-minus"></i>
                        </el-button>
                    </div>
                </el-row>
            </el-col>
            <el-col :span="8">
                <el-row>
                    <div class="titles">
                        <span class="fonts">职业岗位</span>
                        <el-button @click="addElement('position')" type="success" size="mini" style="margin-left:15px;" :disabled="editDisableState">
                            <i class="el-icon-plus"></i>
                        </el-button>
                        <el-button @click="popGrid('position')" type="danger" size="mini" :disabled="editDisableState">
                            <i class="el-icon-minus"></i>
                        </el-button>
                    </div>
                </el-row>
            </el-col>
            <el-col :span="8">
                <el-row>
                    <div class="titles">
                        <span class="fonts">职业证书</span>
                        <el-button @click="addElement('certificate')" type="success" size="mini" style="margin-left:15px;" :disabled="editDisableState">
                            <i class="el-icon-plus"></i>
                        </el-button>
                        <el-button @click="popGrid('certificate')" type="danger" size="mini" :disabled="editDisableState">
                            <i class="el-icon-minus"></i>
                        </el-button>
                    </div>
                </el-row>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="8" style="margin-right:-1px;">
                <el-table :data="domain" ref="domain" class="tb-edit" border fit highlight-current-row
                    :show-header="false" :row-style="{ height: '65px' }" @selection-change="hanleDomainSelection"
                    @row-click="(row, column, event) => handleRowClick('domain', row, column, event)">
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column label="职业领域">
                        <template slot-scope="scope">
                            <span class="el-edit">
                                <el-select class="domain" v-model="scope.row.jzXgbh"
                                    @change="(val) => hanleDomainChange(val, scope)"
                                    @focus="handleDomainFocus" filterable>
                                    <el-option v-for="item in optionDomain" :key="item.value" :label="item.label"
                                        :value="item.value" :disabled="item.disabled">
                                    </el-option>
                                </el-select>
                            </span>
                            <span>{{ scope.row.jzZylymc }}</span>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
            <el-col :span="8">
                <el-table :data="position" ref="position" class="tb-edit" border fit highlight-current-row
                    :show-header="false" :row-style="{ height: '65px' }" @selection-change="hanlePositionSelection"
                    @row-click="(row, column, event) => handleRowClick('position', row, column, event)">
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column label="职业岗位">
                        <template slot-scope="scope">
                            <span class="el-edit">
                                <el-select class="domain" v-model="scope.row.jzXgbh"
                                    @change="(val) => hanlePositionChange(val, scope)"
                                    @focus="handlePositionFocus" filterable>
                                    <el-option v-for="item in optionPosition" :key="item.value" :label="item.label"
                                        :value="item.value" :disabled="item.disabled">
                                    </el-option>
                                </el-select>
                            </span>
                            <span>{{ scope.row.jzZygwmc }}</span>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
            <el-col :span="8" style="margin-left:-1px;">
                <el-table :data="certificate" ref="certificate" class="tb-edit" border fit highlight-current-row
                    :show-header="false" :row-style="{ height: '65px' }" @selection-change="hanleCertSelection"
                    @row-click="(row, column, event) => handleRowClick('certificate', row, column, event)">
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column label="职业技能等级证书或职业资格证书(名称、等级、颁证单位)">
                        <template slot-scope="scope">
                            <span class="el-edit">
                                <el-select class="domain" v-model="scope.row.jzXgbh"
                                    @change="(val) => hanleCertChange(val, scope)"
                                    @focus="handleCertFocus" filterable>
                                    <el-option v-for="item in optionCert" :key="item.value" :label="item.label" :value="item.value"
                                        :disabled="item.disabled">
                                    </el-option>
                                </el-select>
                            </span>
                            <span>{{ scope.row.jzZyzsmc }}</span>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
        </el-row>
        <!-- <el-table
                :data="xxx"
                :height="xxx"
                ref="occupationScopeTable"
                v-loading.body="xxx"
                :header-cell-style="{ 'text-align': 'center' }"
                element-loading-text="信息加载中"
                border
                fit
                style="width: 100%"
                :span-method="spanMethod"
            >
                <el-table-column label="序号"
                    type="index"
                    :index="xxx"
                ></el-table-column>
                <el-table-column label="职业领域"></el-table-column>
                <el-table-column label="职业岗位"></el-table-column>
                <el-table-column label="职业技能等级证书或职业资格证书(名称、等级、颁证单位)"></el-table-column>
                <el-table-column label="教学要求"></el-table-column>
                <el-table-column label="总学时"></el-table-column>
                <el-table-column label="学分"></el-table-column>
            </el-table> -->
    </div>
</template>


<script>
    export default {
        props: ["editDisableState"],
        data() {
            return {
                domain: [],
                position: [],
                certificate: [],
                domainMult: [],
                positionMult: [],
                certificateMult: [],
                optionDomain: [],
                optionPosition: [],
                optionCert: [],
                belong: null,
            };
        },
        mounted() {
            this.loadDomain();
            this.loadCertificate();
        },
        methods: {
            loadDomain() {
                this.$api.teachingManage.teachingScheme
                    .loadDomain()
                    .then((res) => {
                        this.optionDomain = res.data;
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            },
            loadPosition() {
                let domainSet = new Set();
                this.domain.forEach((e) => {
                    domainSet.add(e.jzXgbh);
                });
                let param = {
                    domain: domainSet,
                };
                this.$api.teachingManage.teachingScheme
                    .loadPosition({
                        data: param,
                    })
                    .then((res) => {
                        this.optionPosition = res.data;
                        this.optionPosition.forEach((item) => {
                            item.disabled = false;
                            for (let i = 0; i < this.position.length; ++i) {
                                if (this.position[i].jzXgbh == item.value)
                                    item.disabled = true;
                            }
                        });
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            },
            loadCertificate() {
                this.$api.teachingManage.teachingScheme
                    .loadCertificate()
                    .then((res) => {
                        this.optionCert = res.data;
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            },
            hanleDomainChange(val, scope) {
                let obj = {};
                obj = this.optionDomain.find((item)=>{
                    return item.value === val;
                });
                scope.row.jzZylymc = obj.label;

                this.belong = scope.row.jzXgbh;
                this.loadPosition();
            },
            hanlePositionChange(val, scope){
                let obj = {};
                obj = this.optionPosition.find((item)=>{
                    return item.value === val;
                });
                scope.row.jzZygwmc = obj.label;
            },
            hanleCertChange(val, scope){
                let obj = {};
                obj = this.optionCert.find((item)=>{
                    return item.value === val;
                });
                scope.row.jzZyzsmc = obj.label;
            },
            handleDomainFocus() {
                this.optionDomain.forEach((item) => {
                    item.disabled = false;
                    for (let i = 0; i < this.domain.length; ++i) {
                        if (this.domain[i].jzXgbh == item.value)
                            item.disabled = true;
                    }
                });
            },
            handlePositionFocus() {
                this.loadPosition();
            },
            handleCertFocus() {
                this.optionCert.forEach((item) => {
                    item.disabled = false;
                    for (let i = 0; i < this.certificate.length; ++i) {
                        if (this.certificate[i].jzXgbh == item.value)
                            item.disabled = true;
                    }
                });
            },
            addElement(type) {
                if (type == "domain") {
                    let origin = {
                        id: this.getId(6),
                        jzLx: "1",
                        jzXgbh: "",
                        jzZylymc: "",
                    };
                    let copy = { ...origin
                    };
                    this.domain.push(copy);
                    this.$refs.domain.setCurrentRow(copy);
                    this.handleRowClick("domain");
                }
                if (type == "position") {
                    let origin = {
                        id: this.getId(6),
                        jzLx: "2",
                        jzXgbh: "",
                        jzZygwmc: "",
                        belong: this.belong,
                    };
                    let copy = { ...origin
                    };
                    this.position.push(copy);
                    this.$refs.position.setCurrentRow(copy);
                    this.handleRowClick("position");
                }
                if (type == "certificate") {
                    let origin = {
                        id: this.getId(6),
                        jzLx: "3",
                        jzXgbh: "",
                        jzZyzsmc: "",
                    };
                    let copy = { ...origin
                    };
                    this.certificate.push(copy);
                    this.$refs.certificate.setCurrentRow(copy);
                    this.handleRowClick("certificate");
                }
            },
            popGrid(type) {
                if (type == "domain") {
                    if (this.domainMult.length == 0) return;

                    this.domainMult.forEach((item) => {
                        let del_id = item.jzXgbh;
                        for (let i = this.position.length - 1; i >= 0; i--) {
                            if (this.position[i].belong == del_id)
                                this.position.splice(i, 1);
                        }
                    });

                    this.arrayMinus(this.domain, this.domainMult);
                    this.$nextTick(() => {
                        this.$refs.domain.clearSelection();
                    });
                    this.loadPosition();
                }
                if (type == "position") {
                    if (this.positionMult.length == 0) return;
                    this.arrayMinus(this.position, this.positionMult);
                    this.$nextTick(() => {
                        this.$refs.position.clearSelection();
                    });
                }
                if (type == "certificate") {
                    if (this.certificateMult.length == 0) return;
                    this.arrayMinus(this.certificate, this.certificateMult);
                    this.$nextTick(() => {
                        this.$refs.certificate.clearSelection();
                    });
                }
            },
            arrayMinus(arr1, arr2) {
                arr1.forEach((item) => {
                    item.id = this.getId();
                });
                arr2.forEach((item) => {
                    item.id = this.getId();
                });
                //arr1 - arr2
                for (let i = arr1.length - 1; i >= 0; i--) {
                    let x = arr1[i].id;
                    for (let k = arr2.length - 1; k >= 0; k--) {
                        let y = arr2[k].id;
                        if (x == y) {
                            arr1.splice(i, 1);
                            arr2.splice(k, 1);
                            break;
                        }
                    }
                }
            },
            getId(length) {
                return Number(
                    Math.random().toString().substr(3, length) + Date.now()
                ).toString(36);
            },
            hanleDomainSelection(val) {
                this.domainMult = val;
            },
            hanlePositionSelection(val) {
                this.positionMult = val;
            },
            hanleCertSelection(val) {
                this.certificateMult = val;
            },
            handleRowClick(refName, row, column, event) {
                //不可编辑处理
                if(this.editDisableState){
                    this.$refs[refName].setCurrentRow();
                }
                this.$emit("changeEditRow", refName);
            },
        },
    };
</script>

<style scoped>
    .domain {
        width: 100%;
    }

    .tb-edit .el-edit {
        display: none;
    }

    .tb-edit .current-row .el-edit {
        display: block;
    }

    .tb-edit .current-row .el-edit+span {
        display: none;
    }
</style>



// WEBPACK FOOTER //
// occupationScope.vue?dd5f9d92